import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
    private readonly darkModeClass = 'dark-mode';

    constructor() {
        const savedTheme = localStorage.getItem('theme');
        if (savedTheme === 'dark') {
            this.enableDarkMode();
        } else {
            this.enableLightMode();
        }
    }

    enableDarkMode(): void {
        document.body.classList.add(this.darkModeClass);
        localStorage.setItem('theme', 'dark');
    }

    enableLightMode(): void {
        document.body.classList.remove(this.darkModeClass);
        localStorage.setItem('theme', 'light');
    }

    toggleTheme(): void {
        if (this.isDarkMode()) {
            this.enableLightMode();
        } else {
            this.enableDarkMode();
        }
    }

    isDarkMode(): boolean {
        return document.body.classList.contains(this.darkModeClass);
    }
}
